import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';

import { OrderStatusStep } from '@api/order/order.models';
import { SendOrderStatusAnalyticPageEvent } from '@pages/order-status/store/order-status-analytics.actions';
import { SetOrderNumber } from '@pages/order-status/store/order-status.actions';
import { selectOrderStatusStep } from '@pages/order-status/store/order-status.selectors';

@Component({
    selector: 'order-status-search',
    templateUrl: './order-status-search.component.html',
})
export class OrderStatusSearchComponent implements OnInit {
    public form = this.fb.group({
        order: new FormControl(null, { validators: [Validators.required, Validators.minLength(9), Validators.pattern('^[0-9]*$')], updateOn: 'blur' }),
    });

    public errorMessageList: Record<string, string> = {
        required: 'dev.orderStatus.requiredOrderId',
        minlength: 'dev.orderStatus.error.minlegth',
        pattern: 'dev.orderStatus.order.invalid',
    };

    public OrderStatusStep = OrderStatusStep;

    public step$ = this.store.select(selectOrderStatusStep);

    constructor(
        private readonly store: Store,
        private readonly fb: FormBuilder,
    ) { }

    public ngOnInit(): void {
        this.store.dispatch(SendOrderStatusAnalyticPageEvent({ actionType: 'localizar_pedido' }));
    }

    public checkOrder() {
        if (this.form.valid) {
            this.store.dispatch(SetOrderNumber({ orderNumber: this.form.controls.order.value }));
            this.form.reset();
        } else {
            this.form.controls.order.markAsDirty();
        }
    }
}
